'use client';

import type { FC, HTMLAttributes } from 'react';
import { cx } from '@/ui/utils/cx';
import styles from './LoadingArticleContent.module.css';

interface LoadingArticleContentProps extends HTMLAttributes<HTMLDivElement> {
  loading: boolean;
}

export const LoadingArticleContent: FC<LoadingArticleContentProps> = ({
  loading,
  className,
  ...rest
}) => (
  <div
    className={cx(styles.root, className)}
    data-loading={loading}
    {...rest}
  />
);
